import { PASSWORD_RECOVERY_STEP_TYPES } from '@namespace/auth';
import SetNewPassword from './SetNewPassword';

export const passwordRecoveryStepsMap = {
  [PASSWORD_RECOVERY_STEP_TYPES.SET_NEW_PASSWORD_RECOVERY]: SetNewPassword
};
